import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';
import formurlencoded from 'form-urlencoded';

/**
 * Send registration verification code to email
 * @param {string} email - User's email address
 * @returns {Promise} Response with token and verify_code_link
 */
export async function sendRegistrationCode(email) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    isPublic: true,
  };

  const { data } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/registration_code/`,
      formurlencoded({ email }),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return data;
}

/**
 * Check registration code status
 * Token is in URL path, not body
 */
export async function checkCodeStatus(token) {
  const requestConfig = {
    isPublic: true,  // No authentication required
  };

  const { data } = await getAuthenticatedHttpClient()
    .get(
      `${getConfig().LMS_BASE_URL}/verify_registration_code/${token}/`,
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return data;
}

/**
 * Verify the 6-digit registration code
 * @param {string} token - The unique token for this registration
 * @param {string} code - The 6-digit verification code
 * @returns {Promise} Response data from the API
 */
export async function verifyRegistrationCode(token, code) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    isPublic: true,
  };

  const { data } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/verify_registration_code/${token}/`,
      formurlencoded({ code }),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return data;
}
